var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.3448L11.7808 20.7084C10.6514 21.8556 9.11962 22.5 7.52238 22.5C5.92515 22.5 4.39333 21.8556 3.26391 20.7084C2.1345 19.5613 1.5 18.0055 1.5 16.3832C1.5 14.761 2.1345 13.2051 3.26391 12.058L12.4831 2.69437C13.236 1.92963 14.2572 1.5 15.322 1.5C16.3869 1.5 17.4081 1.92963 18.161 2.69437C18.914 3.45912 19.337 4.49633 19.337 5.57785C19.337 6.65936 18.914 7.69658 18.161 8.46132L8.93184 17.825C8.55537 18.2073 8.04476 18.4222 7.51235 18.4222C6.97994 18.4222 6.46933 18.2073 6.09286 17.825C5.71639 17.4426 5.50489 16.924 5.50489 16.3832C5.50489 15.8425 5.71639 15.3239 6.09286 14.9415L14.6098 6.30126",
    stroke: "#919EAB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconPaperclip);
export default __webpack_public_path__ + "static/media/button-icon-paperclip.b2fdfdea32a9d36806e2c0f5f99a4a1c.svg";
export { ForwardRef as ReactComponent };